export default __webpack_public_path__ + "static/media/expand-less.f0cc1e85.svg";